import { baseWebsocketUrl } from "@/constants/apiRoutes";
import { io, Socket } from "socket.io-client";
import { getAccessToken } from "./cookieManipulation";

let socket: Socket | null = null;
let currentUserId: string | undefined;

export const getSocket = (): Socket => {
  if (!socket) {
    socket = io(baseWebsocketUrl, {
      autoConnect: false,
      transports: ["websocket", "polling"],
      path: "/iosocket/", // Default socket.io path
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 10000,
      reconnectionAttempts: Infinity,
      auth: (cb) => cb({ token: getAccessToken(), userId: currentUserId }),
    });
  }

  return socket;
};

export const connectSocket = (userId?: string) => {
  const socket = getSocket();

  if (userId) currentUserId = userId;
  if (!socket.connected) socket.connect();

  return socket;
};

export const disconnectSocket = () => {
  socket?.disconnect();
};
